import React, { Component } from "react";
import styled from "styled-components";
import { Route, Redirect } from "react-router-dom";
import { Scrollbars } from "react-custom-scrollbars";
import ChannelPanel from "./channel-panel/ChannelPanel";
import CustomerFieldPanel from "./customer-field-panel/CustomerFieldPanel";
import LabelPanel from "./label-panel/LabelPanel";
import TeamPanel from "./team-panel/TeamPanel";
import MenuPanel from "./MenuPanel";
import ConfigPanel from "./ConfigPanelWithQueryMutation";
// import AutoDistributionPanel from "./auto-distribution/AutoDistributionPanel";
import TemplateReplyPanel from "./template-reply/TemplateReplyPanel";
// import BillingPanel from "./billing/BillingPanel";
// import OngkirPanel from "./ongkir-panel/OngkirPanel";
// import LiveChatPanel from "./livechat-template-reply/LiveChatPanel";

const Panels = [
  { name: "Account", route: "/account", component: ChannelPanel },
  {
    name: "Team Management",
    route: "/team-management",
    component: TeamPanel
  },
  { name: "Configuration", route: "/configuration", component: ConfigPanel },
  { name: "Label", route: "/label", component: LabelPanel },
  {
    name: "Customer Field",
    route: "/customer-field",
    component: CustomerFieldPanel
  },
  // {
  //   name: "Auto Distribution",
  //   route: "/auto-distribution",
  //   component: AutoDistributionPanel
  // },
  {
    name: "Template Reply",
    route: "/template-reply",
    component: TemplateReplyPanel
  },
  // {
  //   name: "Billing",
  //   route: "/billing",
  //   component: BillingPanel
  // },
  // {
  //   name: "Ongkir",
  //   route: "/ongkir",
  //   component: OngkirPanel
  // },
  // {
  //   name: "LiveChat Template Reply",
  //   route:"/livechat-template-reply",
  //   component: LiveChatPanel
  // }
];

export default class ModuleSupervisorSetting extends Component {
  render() {
    const match = this.props.match;
    return (
      <Scrollbars>
        <Wrapper>
          <MenuPanel menu={Panels} />
          {Panels.map(panel => (
            <Route
              exact
              key={panel.name}
              path={match.url + panel.route}
              component={panel.component}
            />
          ))}
          <Route
            exact
            path={match.url + "/"}
            render={() => <Redirect to={match.url + "/team-management"} />}
          />
        </Wrapper>
      </Scrollbars>
    );
  }
}

const Wrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  padding: 20px;
`;



// WEBPACK FOOTER //
// ./src/module-supervisor-setting/ModuleSupervisorSetting.js